import { render } from "./UiErrorState.vue?vue&type=template&id=8482b482"
import script from "./UiErrorState.vue?vue&type=script&lang=js"
export * from "./UiErrorState.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__